
export const Levels = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  DEBUG: 'debug'
};

export class Logger {

  static page = "unknown";

  static setContext(identifier, context) {

    if (typeof identifier !== "string" || typeof context !== "object") {
      return;
    }

    Logger.page = context.page || "unknown";
  }

  static setTags(tags) {

    if (typeof tags !== "object") {
      return;
    }

    for (const [key, val] of Object.entries(tags)) {

      if (!key || !val) {
        continue;
      }
    }
  }

  static breadcrumb(
    message,
    category,
    type,
    data,
    level = Levels.INFO
  ) {

    if (!message) {
      return;
    }
  }

  static info(
    message,
    component,
    context = {},
    tags = {}
  ) {

    if (!message) {
      return;
    }
  }

  static error(
    error,
    component,
    context = {},
    tags = {}
  ) {

    try {

      const isErrorInstance = error instanceof Error;

      if (!isErrorInstance && typeof error === "object") {
        error = Error(JSON.stringify(error));
      }

      if (!isErrorInstance && typeof error === "string") {
        error = Error(error);
      }

      if (!(error instanceof Error)) {
        // unsupported error type
        return;
      }
    }
    catch(e) {
      Logger.error(Error("Unable to log sentry exception"));
    }
  }
}